module.exports = __webpack_public_path__ + "img/course.92c99bd2.png";